import { SVGProps } from 'react';

const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 25 25" {...props}>
    <path
      stroke="#B3261E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m18.333 6.5-12 12M6.333 6.5l12 12"
    />
  </svg>
);

export default SvgClose;
